import Vue from 'vue';
import Vuex from 'vuex';
import {AscDesc, ResultType, XHTTPService} from '@/shared/xhttp';
import {NumberFilter} from '@/shared/filter';
import {
	PaginatorActionWithFilters,
	PaginatorFilterState,
	PaginatorMutationFilter,
	StandardAction
} from '@/shared/utils';
import {Pile, Fournisseur} from '@/models';
import {PileService} from '@/xhttp';
import store from '@/stores';

Vue.use(Vuex);

export class PileFilter {

	Name: string = '';
	address: string = '';
	zipCode: string = '';
	town: string = '';

	public clear(): void {
		this.Name = '';
		this.address = '';
		this.zipCode = '';
		this.town = '';
	}

	public toString(): string {
		return JSON.stringify({
			Name: this.Name,
			address : this.address,
			zipCode : this.zipCode,
			town : this.town,
		});
	}
}

class PileState extends PaginatorFilterState<PileFilter> {
	public pile: Pile = null;
	public piles: ResultType<Pile> = null;
	public constructor() {
		super(new PileFilter(), 'piles', 'pile', 'id', AscDesc.DESC, 50);
	}
}

class PileStore {

	@XHTTPService(() => Pile)
	private pileService: PileService;

	public state: PileState = new PileState();

	public mutations = {
		...PaginatorMutationFilter(() => storePile, 'piles', 'pile'),
	};

	public actions = {
		...PaginatorActionWithFilters<Pile, PileState>(() => Pile, 'piles', 'pile'),
		...StandardAction<Pile, PileState>(() => Pile, 'pile'),
	};

}
const instance = new PileStore();
const storePile = new Vuex.Store(instance);
store.registerModule('pile', storePile);
export default storePile;